import { AndroidDependenciesDependencyReport, AndroidDependenciesReport } from '@/types/androidDependencies';

export const VERSION_STATUS_LABELS: Record<string, string> = {
    'up-to-date': 'Up to date',
    'update-available': 'Update available',
    'ahead-of-latest': 'Ahead of latest',
    'no-current-version': 'No current version',
    'invalid-version': 'Invalid version',
    'dynamic-version': 'Dynamic version',
    'pinned-to-commit': 'Pinned to a commit',
    'managed-by-bom': 'Managed by BOM',
    'managed-by-plugin': 'Managed by plugin',
    'not-on-public-repository': 'Not on a public repository',
    'version-check-failed': 'Version check failed',
};

export const VERSION_STATUS_COLORS: Record<string, string> = {
    'up-to-date': 'green',
    'update-available': 'blue',
    'ahead-of-latest': 'gold',
    'no-current-version': 'default',
    'invalid-version': 'red',
    'dynamic-version': 'purple',
    'pinned-to-commit': 'purple',
    'managed-by-bom': 'geekblue',
    'managed-by-plugin': 'geekblue',
    'not-on-public-repository': 'default',
    'version-check-failed': 'red',
};

export const RESOLUTION_LABELS: Record<string, string> = {
    'resolved-direct': 'Resolved (direct)',
    'resolved-indirect': 'Resolved (transitive)',
    'declared-direct': 'Declared only',
    'declared-in-catalog': 'In version catalog',
    'declared-plugin': 'Gradle plugin',
};

export const formatVersionStatusLabel = (versionStatus?: string): string =>
    versionStatus ? (VERSION_STATUS_LABELS[versionStatus] ?? versionStatus) : '—';

export const versionStatusTagColor = (versionStatus?: string): string =>
    versionStatus ? (VERSION_STATUS_COLORS[versionStatus] ?? 'default') : 'default';

export const formatResolutionLabel = (status: string): string => RESOLUTION_LABELS[status] ?? status;

export const isIndirect = (row: AndroidDependenciesDependencyReport): boolean => row.status === 'resolved-indirect';

export const isCatalogOnly = (row: AndroidDependenciesDependencyReport): boolean =>
    row.status === 'declared-in-catalog';

export const isGradlePlugin = (row: AndroidDependenciesDependencyReport): boolean => row.status === 'declared-plugin';

export const dependencyGraphChain = (graph?: string[]): string | undefined => {
    if (!graph || graph.length === 0) {
        return undefined;
    }
    if (graph.length === 1 && graph[0] === 'unknown') {
        return undefined;
    }
    return graph.join(' → ');
};

export const countUpdates = (report?: AndroidDependenciesReport): number =>
    report?.dependencies?.filter((dep) => dep.versionStatus === 'update-available').length ?? 0;

export const totalDeps = (report?: AndroidDependenciesReport): number => report?.dependencies?.length ?? 0;
